import { render, staticRenderFns } from "./body-top.vue?vue&type=template&id=38be76d4"
import script from "./body-top.vue?vue&type=script&lang=js"
export * from "./body-top.vue?vue&type=script&lang=js"
import style0 from "./body-top.vue?vue&type=style&index=0&id=38be76d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports